import config from '../../../../config/config';
import { Configuration, ProjectPhasesApi } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const projectPhasesApi = new ProjectPhasesApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
